import request from '@/utils/request'
import { SSO } from '@jy/constant/url'

export function getMenus () {
  return request({
    url: SSO.path + '/auth/portal/authBtn/list',
    method: 'get'
  })
}
